import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";

const DashboardProgressSection = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 8, position: "relative", zIndex: 2 }}>
      <Box
        sx={{
          backgroundColor: "#1E3A3A",
          borderRadius: "20px",
          padding: { xs: "40px 24px", md: "60px 40px", lg: "80px 60px" },
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
          alignItems: "center",
          gap: { xs: 4, lg: 8 },
          minHeight: "600px",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Left Section - Text Content */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            height: "100%",
            zIndex: 2,
          }}
        >
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: "2rem", md: "2.5rem", lg: "3rem" },
              fontWeight: 700,
              fontFamily: "Outfit",
              color: "#FFFFFF",
              mb: 4,
              lineHeight: 1.2,
            }}
          >
            All Your Progress in One Dashboard
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: "1rem", md: "1.1rem" },
              fontWeight: 400,
              fontFamily: "Outfit",
              color: "rgba(255, 255, 255, 0.9)",
              lineHeight: 1.6,
              mb: 6,
              maxWidth: "500px",
            }}
          >
            Stay in control with Fitify's powerful, easy to use dashboard. Track
            your meals, workouts, client progress, and performance insights all
            in one place.
            <br /> Whether you're a coach or an individual, the smart dashboard
            keeps you organized, motivated, and focused on results.
          </Typography>

          {/* <Button
            sx={{
              backgroundColor: "#4A4A4A",
              color: "#5BF2FF",
              fontWeight: 600,
              borderRadius: "10px",
              textTransform: "none",
              padding: "12px 32px",
              fontSize: "1rem",
              fontFamily: "Outfit",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
              alignSelf: "flex-start",
              "&:hover": {
                backgroundColor: "#5A5A5A",
                boxShadow: "0 6px 16px rgba(0, 0, 0, 0.4)",
              },
            }}
          >
            Get Started Today
          </Button> */}
        </Box>

        {/* Right Section - Tablet Mockup */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            height: { xs: "400px", md: "500px" },
          }}
        >
          {/* Tablet Screen */}
          <Box
            sx={{
              width: "100%",
              height: "100%",
              overflow: "hidden",
              position: "relative",
            }}
          >
            <Box
              component="img"
              src={require("assets/images/progress.png")}
              alt="Fitify Dashboard"
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default DashboardProgressSection;
